import { render, staticRenderFns } from "./ProcessNewArticle.vue?vue&type=template&id=0e3157f2&scoped=true"
import script from "./ProcessNewArticle.vue?vue&type=script&lang=js"
export * from "./ProcessNewArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3157f2",
  null
  
)

export default component.exports